import React, { Component } from 'react';
import classnames from 'classnames';
import Cookies from 'universal-cookie';

import { utcToPtDateString } from 'lib/date';

const { REACT_APP_NAUTH_TOKEN_COOKIE_V1: nauthTokenCookie } = process.env;

/**
 * Show user's session expiration time
 */
export default class SessionExpiration extends Component {
  static PRETTY_FORMAT = 'MM/DD h:mm a z';

  static MILLISECONDS = 1000;

  static SECONDS = 60;

  static THIRTY_MINUTES = 30 * SessionExpiration.SECONDS * SessionExpiration.MILLISECONDS;

  constructor(props) {
    super(props);

    this.state = {
      sessionExpiration: null,
      warnAboutExpiration: false
    };

    this.cookies = new Cookies();
  }

  componentDidMount() {
    const sessionExpiration = this.tokenExpiration();

    if (!sessionExpiration) {
      return;
    }

    const currentTime = new Date().getTime();
    const timeUntilExpiration = sessionExpiration * 1000 - currentTime;
    const expiringSoon = timeUntilExpiration < SessionExpiration.THIRTY_MINUTES;

    if (expiringSoon) {
      this.setState({
        sessionExpiration,
        warnAboutExpiration: true
      });
    } else {
      const updateAtTime = timeUntilExpiration - SessionExpiration.THIRTY_MINUTES;
      this.handlePendingExpiration(updateAtTime);
      this.setState({
        sessionExpiration,
        warnAboutExpiration: false
      });
    }
  }

  handlePendingExpiration(timeout) {
    setTimeout(() => {
      this.setState({ warnAboutExpiration: true });
    }, timeout);
  }

  tokenExpiration() {
    return this.cookies.get(`${nauthTokenCookie}Expiration`);
  }

  render() {
    const { sessionExpiration, warnAboutExpiration } = this.state;

    if (!sessionExpiration) {
      return null;
    }

    const expirationDate = new Date(0).setUTCSeconds(sessionExpiration);
    const readableDate = utcToPtDateString(expirationDate, SessionExpiration.PRETTY_FORMAT);

    return (
      <span
        className={classnames('p-2', warnAboutExpiration && 'font-weight-bold text-danger')}
        data-test-id="sessionExpiration-expires"
      >
        Session Expires:&nbsp;
        {readableDate}
      </span>
    );
  }
}
